import React from "react"
import { Link } from "gatsby"

import {
  pageCtn,
  advertCtnHoriz,
  gameCtn, gameFrame
} from './template-styles/game-play-page-styles.module.css'



const gamesListTemplate = props => {
  const { pageContext } = props
  const { pageContent } = pageContext

  return (
    <div className={pageCtn}>
        <div className={advertCtnHoriz}>
            Advertisement Top
        </div>
        <div className={gameCtn}>
            <iframe className={gameFrame} src={pageContent.gameSdkUrl}>
            </iframe>
        </div>
        <div>{/* JSON.stringify(pageContent, null, 2) */}</div>
        <div className={advertCtnHoriz}>
            Advertisement Bottom 
        </div>
    </div>
  )
}
export default gamesListTemplate
